/**
 * Resolves `/control/...` URLs for the browser.
 *
 * Default: keep paths relative (`/control/...`) so the page origin (localhost, Docker/nginx,
 * or CloudFront with a `/control/*` behavior → API origin) proxies API traffic — no CORS.
 *
 * Only when runtime-config sets `CTRL_API_DIRECT` to true (deploy with
 * `HPI_CTRL_API_DIRECT=true`) are requests sent to `CTRL_HOST` / `HPI_CTRL_HOST`. That mode
 * requires the control API to allow CORS for the admin UI origin.
 */
export function resolveControlApiUrl(url) {
  if (typeof url !== 'string' || !url.startsWith('/control')) {
    return url
  }
  if (typeof window === 'undefined') {
    return url
  }
  const cfg = window.__APP_CONFIG__ || {}
  const useDirect =
    cfg.CTRL_API_DIRECT === true ||
    cfg.CTRL_API_DIRECT === 'true' ||
    cfg.HPI_CTRL_API_DIRECT === true ||
    cfg.HPI_CTRL_API_DIRECT === 'true'
  if (!useDirect) {
    return url
  }
  const raw = (cfg.CTRL_HOST || cfg.HPI_CTRL_HOST || '').trim().replace(/\/$/, '')
  if (!raw) {
    return url
  }
  return `${raw}${url}`
}
